import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

const DEFAULT_ERROR = 'An error has occurred';
const DEFAULT_DURATION = 5000;

@Injectable()
export class NotificationsService {

  private messageService: MessageService = inject(MessageService);
  private translateService: TranslateService = inject(TranslateService);

  public success(message: string, duration?: number): void {
    const summary: string = this.translateService.instant('common_success').toUpperCase();
    duration = duration || DEFAULT_DURATION;
    this.messageService.add({ severity: 'success', summary: summary, detail: message, life: duration });
  }

  public error(message?: string, duration?: number): void {
    duration = duration || DEFAULT_DURATION;
    message = message || DEFAULT_ERROR;
    this.messageService.add({ severity: 'error', summary: 'ERROR', detail: message, life: duration });
  }

  public warning(message: string, duration?: number): void {
    const summary: string = this.translateService.instant('common_warning').toUpperCase();
    duration = duration || DEFAULT_DURATION;
    this.messageService.add({ severity: 'warn', summary: summary, detail: message, life: duration });
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  public notifyErrorFromModelState(modelState: any): void {
    const properties: Array<string> = Object.keys(modelState);
    properties.forEach(property => {
      const messages: Array<string> = modelState[property];
      messages.forEach(message => {
        this.error(message);
      });
    });
  }
}
